import FeaturedShows from 'show-index/components/featured-shows';
import LetterNav from 'show-index/components/letter-nav';
import ShowSearch from 'show-index/components/show-search';
import ShowList from 'show-index/components/show-list';
import styles from './styles.less';
import { observer } from 'mobx-react';


@observer(['showsStore'])
class ShowIndexContent extends React.Component {
    render() {
        const className = cx(styles.root, this.props.className);
        return (
            <div className={ className }>
                <FeaturedShows
                    className={ styles.featuredShows }
                    shows={ this.props.showsStore.featuredShows }
                />
                <LetterNav
                    className={ styles.letterNav }
                    letters={ this.props.showsStore.letters }
                    onSelectLetter={ this.handleLetterSelect }
                    selectedLetter={ this.props.showsStore.selectedLetter }
                />
                <ShowSearch
                    onChange={ this.handleSearch }
                    value={ this.props.showsStore.searchInputValue }
                />
                <ShowList
                    className={ styles.showsList }
                    shows={ this.props.showsStore.filteredShows }
                />
            </div>
        );
    }

    handleLetterSelect = (letter) => {
        this.props.showsStore.setSearchInputValue('');
        this.props.showsStore.selectLetter(letter === this.props.showsStore.selectedLetter ? null : letter);
    };

    handleSearch = (value) => {
        this.props.showsStore.selectLetter(null);
        this.props.showsStore.setSearchInputValue(value);
    };
}


export default ShowIndexContent;



// WEBPACK FOOTER //
// ./src/show-index/containers/content/index.js